module.exports = "<div class=\"top(0-1) bottom(0-1) width(max) darken(on)\" style=\"height: 1px\"></div>\n";